var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"audit-aside"},[_c('ul',{staticClass:"aside-list"},_vm._l((this.getGroupMenuList),function(aside,index){return _c('li',{key:index,staticClass:"list-item",class:{ active: _vm.isActive === aside.url }},[_c('a',{class:{ active: _vm.isActive === aside.url },attrs:{"href":aside.url}},[_vm._v(_vm._s(aside.name))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3084d4a0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AdminAside.vue
// module id = null
// module chunks = 